// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom_button[data-v-0a4d7850]{height:1.06667rem;opacity:1;background:#1b65fd;border-radius:.21333rem;font-size:.37333rem;font-weight:400;text-align:center;color:#fff;line-height:1.06667rem;margin-top:.21333rem}.bottom_button-container[data-v-0a4d7850]{background-color:#fff;padding:.21333rem;border-top:.02667rem solid #f7f8f9}", ""]);
// Exports
module.exports = exports;
